import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b7d6bee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contract-checkbox" }
const _hoisted_2 = { class: "contract-checkbox__agreement" }
const _hoisted_3 = { class: "contract-checkbox__agreement-text" }

import { Prop, PropType, ref } from 'vue'
import { SIZES } from '@/enums/components'
import BaseCheckbox from '@/components/BaseCheckbox.vue'
import ModalWrapper from '@/components/ModalWrapper.vue'
import ServiceProviderContractEST from '@/components/settings/ServiceProviderContractEST.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ServiceProviderContractCheckbox',
  props: {
  modelValue: {
    type: Boolean,
    required: true,
  },
  errors: {
    type: Array as PropType<string[] | undefined>,
    default: undefined,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
},
  emits: ['update:ModelValue'],
  setup(__props) {

const props = __props



const isContractModalOpen = ref<boolean>(false)



return (_ctx: any,_cache: any) => {
  const _component_RequiredAsterisk = _resolveComponent("RequiredAsterisk")!
  const _component_InputErrorMessages = _resolveComponent("InputErrorMessages")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BaseCheckbox, {
        class: "contract-checkbox__checkbox",
        name: "terms_and_conditions",
        "model-value": __props.modelValue,
        label: '',
        disabled: __props.disabled,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', !__props.modelValue)))
      }, null, 8, ["model-value", "disabled"]),
      _createElementVNode("div", _hoisted_3, [
        _createTextVNode(_toDisplayString(_ctx.$t('settingsProfile.agreeToTerms')) + " ", 1),
        _createElementVNode("span", {
          class: "contract-checkbox__contract",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (isContractModalOpen.value = true), ["prevent"]))
        }, _toDisplayString(_ctx.$t('settingsProfile.contract')), 1),
        _createVNode(_component_RequiredAsterisk)
      ])
    ]),
    _createVNode(_component_InputErrorMessages, { "model-value": __props.errors }, null, 8, ["model-value"]),
    (isContractModalOpen.value)
      ? (_openBlock(), _createBlock(ModalWrapper, {
          key: 0,
          title: "Üldtingimused",
          "modal-size": _unref(SIZES).LARGE,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (isContractModalOpen.value = false))
        }, {
          content: _withCtx(() => [
            _createVNode(ServiceProviderContractEST, {
              onClose: _cache[2] || (_cache[2] = ($event: any) => (isContractModalOpen.value = false))
            })
          ]),
          _: 1
        }, 8, ["modal-size"]))
      : _createCommentVNode("", true)
  ]))
}
}

})